import './ToDoEmpty.css';

function ToDoEmpty() {
  return (
    <p className='empty-list'>Crea una tarea.</p>
  );
}

export { ToDoEmpty };